import { useEffect, useState } from "react";
import {
  ChartDataParams,
  FormatChartData,
  FormatChartDataWithAverages,
} from "../../../components/recharts/functions";
import {
  lightenColor,
  ReMixChart,
} from "../../../components/recharts/ReMixCharts";
import { ChartType } from "../../../models/chart_model";
import { ExchangeColors } from "../Exchange3/FormatData";
import { renderQuarterTick } from "../../../components/recharts/components";
import FilterMenu from "../../../components/FilterMenu";
import { ProductionData } from "../../../models/gas";
import { getGasProductionData } from "../../../Rest_api/RestApi";
import {
  getFiscalYear,
  GetNumberOfDaysInMonth,
  getQuarter,
} from "../../../extensions/date";
import { GAS_DAY_UNIT } from "../../../Units";
import {
  CHART_TYPES,
  GAS_BAR_GAP,
  GAS_PRODUCTION_TYPE,
  getAvailableMonths,
  getGasColors,
  INTERVALS,
} from "./Gas_Const";
import { stringToConsistentColor } from "../../../extensions/string";
import { COLOR_CODES } from "../../../common";
import { SearchBox } from "../../../components/Search";

const GROUP_BY = [
  { key: "state__state_name", label: "State" },
  { key: "production_type", label: "Net/Gross" },
  { key: "production_location_type", label: "Onshore/Offshore" },
  // {key:"", label:"Production Type"},
  // { key: "production_type__production_type", label: "Production Type" },
];
const keys = [
  {
    key: "month",
    label: "Month",
  },
];
const CONSUMPTION = [{ value: "value_mmscmd", label: "value_mmscmd" }];

export function Production() {
  const [productionData, setproductionData] = useState<ProductionData[]>([]);
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);
  const [chartKeys, setChartKeys] = useState({
    keys: [] as string[],
    label: [] as string[],
  });

  const [selectedGroupKeys, setSelectedGroupKeys] = useState<any[]>([
    GROUP_BY[1],
  ]);
  const [selectedKeys, setSelectedKeys] = useState<any[]>(keys);
  const [selctedConsumption, setSelectedConsumption] = useState([
    CONSUMPTION[2],
  ]);
  const [availableMonths, setAvailableMonths] = useState<any[]>([]);
  const [selectedChartType, setSelectedChartType] = useState(CHART_TYPES[1]);
  const [selectedMonthYear, setSelectedMonthYear] = useState<any[]>([]);
  const [selectedLocationType, setLocationType] = useState<string[]>([]);
  const [selectedProductionType, setProductionType] = useState<string[]>([]);
  useEffect(() => {
    _handlefetchData();
  }, []);
  useEffect(() => {
    let filteredData = productionData;
    if (selectedLocationType.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedLocationType.includes(item.production_location_type)
      );
    }
    if (selectedMonthYear.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedMonthYear.map((item) => item.label).includes(item.month_year)
      );
    }
    if (selectedProductionType.length > 0) {
      filteredData = filteredData.filter((item) =>
        selectedProductionType.includes(item.production_type__production_type)
      );
    }
    if (selectedKeys.length == 1) {
      const unique_month_year = filteredData
        .map((item) => item.month_year)
        .filter((value, index, self) => self.indexOf(value) === index);
      if (selectedKeys[0].key == "year") {
        filteredData = filteredData.map((item) => {
          const numberOfDays = GetNumberOfDaysInMonth(item.month, item.year);
          const monthsInYear = unique_month_year.filter((month_year) =>
            month_year.includes(item.year.toString())
          ).length;
          return {
            ...item,
            value_mmscmd: item.value_mmscmd / monthsInYear,
          };
        });
      } else if (selectedKeys[0].key == "month") {
        filteredData = filteredData.map((item) => {
          const number_of_month = unique_month_year.filter((month_year) =>
            month_year.includes(item.month)
          ).length;
          return {
            ...item,
            value_mmscmd: item.value_mmscmd /*/ number_of_month */,
          };
        });
      } else if (selectedKeys[0].key == "fyear") {
        const unique_month_fyear = filteredData
          .map((item) => item.month_fyear)
          .filter((value, index, self) => self.indexOf(value) === index);
        filteredData = filteredData.map((item) => {
          // const numberOfDays = GetNumberOfDaysInMonth(item.month, item.year);
          const monthsInYear = unique_month_fyear.filter((month_year) =>
            month_year.includes(item.fyear.toString())
          ).length;
          return {
            ...item,
            value_mmscmd: item.value_mmscmd / monthsInYear,
          };
        });
      } else if (selectedKeys[0].key == "quarter") {
        const unique_month_quarter = filteredData
          .map((item) => item.month_quarter)
          .filter((value, index, self) => self.indexOf(value) === index);
        filteredData = filteredData.map((item) => {
          const monthsInYear = unique_month_quarter.filter((month_year) =>
            month_year.includes(item.quarter.toString())
          ).length;
          return {
            ...item,
            value_mmscmd: item.value_mmscmd / monthsInYear,
          };
        });
      }
    }

    const par: ChartDataParams = {
      keys: selectedKeys.map((item) => item.key),
      groupBy: selectedGroupKeys
        .map((item) => item.key)
        .concat("production_type__production_type"),
      volumeKey: "value",
      priceKey: "",
      aggregationKeys: ["value_mmscmd"],
      data: filteredData,
    };
    const data = FormatChartData(par);
    setChartData(data.data);
    setChartKeys({
      keys: data.keys,
      label: data.keysLabels,
    });
  }, [
    productionData,
    selectedMonthYear,
    selectedGroupKeys,
    selectedKeys,
    selctedConsumption,
    selectedLocationType,
    selectedProductionType,
  ]);

  function _handleGroupByChange(index: number) {
    if (
      GROUP_BY[index].key === "state__state_name" ||
      GROUP_BY[index].key == "production_location_type"
    ) {
      setProductionType(["Net Production"]);
    } else {
      setProductionType(["Net Production", "Gross Production"]);
    }

    setSelectedGroupKeys([GROUP_BY[index]]);
  }

  function _handleLocationType(item: string) {
    const isSelected = selectedLocationType.find((value) => value === item);
    if (isSelected) {
      setLocationType(selectedLocationType.filter((value) => value !== item));
    } else {
      setLocationType((prev) => [...prev, item]);
    }
  }

  function _handleProductionType(item: string) {
    const isSelected = selectedProductionType.find((value) => value === item);
    if (
      selectedGroupKeys[0].label === "State" ||
      selectedGroupKeys[0].label === "Onshore/Offshore"
    ) {
      setProductionType([item]);
      return;
    }
    if (isSelected) {
      setProductionType(
        selectedProductionType.filter((value) => value !== item)
      );
    } else {
      setProductionType((prev) => [...prev, item]);
    }
  }

  const handleKeySelection = (keyIndex: number) => {
    const selectedKey = INTERVALS[keyIndex]; // The key to be toggled

    setSelectedKeys([selectedKey]);
  };
  function _handleConsumptionSelection(index: number) {
    setSelectedConsumption([CONSUMPTION[index]]);
  }
  async function _handlefetchData() {
    const newData = await getGasProductionData({});
    setproductionData(
      newData.map((item) => {
        return {
          ...item,
          state__state_name: item.state__state_name.includes("Gujarat")
            ? (item.state__state_name =
                item.state__state_name + " " + item.production_location_type)
            : item.state__state_name,
        };
      })
    );
    setAvailableMonths(getAvailableMonths(newData));
  }
  return (
    <div className="tabContent">
    <div className="gas-page-container ">
      <div className="side-filters-container">
        <FilterMenu
          title="Interval"
          items={INTERVALS.map((item) => item.label)}
          selectedItems={selectedKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            handleKeySelection(index);
          }}
        />
        <FilterMenu
          title="Group By"
          showEmptySelected={false}
          items={GROUP_BY.map((item) => item.label)}
          selectedItems={selectedGroupKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            _handleGroupByChange(index);
          }}
        />
        <FilterMenu
          title="Chart Type"
          items={CHART_TYPES.map((item) => item.label)}
          selectedItems={[selectedChartType.label]}
          onSelect={(item, index) => {
            setSelectedChartType(CHART_TYPES[index]);
          }}
        />
        <FilterMenu
          title="Location Type"
          items={productionData
            .map((item) => item.production_location_type)
            .filter((value, index, self) => self.indexOf(value) === index)}
          selectedItems={selectedLocationType}
          onSelect={(item, index) => {
            _handleLocationType(item);
          }}
        />

        <FilterMenu
          title="Production Type"
          items={productionData
            .map((item) => item.production_type__production_type)
            .filter((value, index, self) => self.indexOf(value) === index)}
          selectedItems={selectedProductionType}
          onSelect={(item, index) => {
            _handleProductionType(item);
          }}
        />
      </div>
      <div className="gas-chart-container">
        <div className="gas-heading">
          <h2 className="chartHeading">
            {selectedGroupKeys[0].label == "Net/Gross"
              ? GAS_PRODUCTION_TYPE.map((v) =>
                  v.label.replace(" Production", "")
                ).join(" & ") + " Production (MMSCMD)"
              : selectedProductionType
                  .map((v) => v.replace(" Production", ""))
                  .join(" & ") +
                " Production (MMSCMD) by " +
                selectedGroupKeys[0].label}
          </h2>
          <SearchBox
            options={availableMonths}
            isMany={true}
            placeholder={
              availableMonths.length > 0
                ? `${availableMonths[0].label} to ${
                    availableMonths[availableMonths.length - 1].label
                  }`
                : "Select a date range"
            }
            selectedOptions={selectedMonthYear}
            onChange={(selected: any) => {
              setSelectedMonthYear(selected);
            }}
          />
        </div>

        <ReMixChart
          chartContainerHeight="100vh"
          data={chartData}
          legends={[
            ...selctedConsumption
              .map((item, index1) => {
                return chartKeys.keys
                  .filter((key) => key.includes("Net"))
                  .map((key, index) => {
                    return {
                      dataKey: key + "_" + "value_mmscmd",
                      name: chartKeys.label
                        .filter((key) => key.includes("Net"))
                        [index].replace(
                          selectedGroupKeys[0].label === "State"
                            ? "Net Production"
                            : "",
                          ""
                        ),
                      type: selectedChartType.value,
                      stroke: getGasColors(
                        chartKeys.label.filter((key) => key.includes("Net"))[
                          index
                        ],
                        index
                      ),
                      stackId: selectedChartType.stackId,
                    };
                  });
              })
              .flat(),
            ...selctedConsumption
              .map((item, index1) => {
                return chartKeys.keys
                  .filter((key) => key.includes("Gross"))
                  .map((key, index) => {
                    return {
                      dataKey: key + "_" + "value_mmscmd",
                      name: chartKeys.label
                        .filter((key) => key.includes("Gross"))
                        [index].replace(
                          selectedGroupKeys[0].label === "State"
                            ? "Gross Production"
                            : "",
                          ""
                        ),
                      type: selectedChartType.value,
                      stroke: getGasColors(
                        chartKeys.label.filter((key) => key.includes("Gross"))[
                          index
                        ],
                        index
                      ),

                      stackId:
                        selectedChartType.stackId != undefined
                          ? "gross"
                          : undefined,
                    };
                  });
              })
              .flat(),
          ]}
          barCategoryGap={GAS_BAR_GAP}
          xTick={true}
          xDataKey={selectedKeys[0].key}
          yAxisLabel={`Volume (${GAS_DAY_UNIT})`}
          unit={GAS_DAY_UNIT}
          secondXDataKey={
            selectedKeys.length > 1 ? selectedKeys[1].key : undefined
          }
          rendexSecondXTick={(value: any) => renderQuarterTick(value, 8)}
        />
      </div>
    </div>
    </div>
  );
}
